<template>
<h6 v-if="props.appointments.length == 0">Aucun {{ props.listItemName }}</h6>

<!-- Current month appointments: table on desktop, cards on mobile -->
<div v-if="currentMonthApps.length > 0" class="desktopOnly">
  <DataTable :value="currentMonthApps" :rowClass="rowClass" selectionMode="single" v-model:selection="selectedApp" @rowSelect="rowSelected" responsiveLayout="scroll" >
    <DataTableColumn field="name" header="Nom"></DataTableColumn>
    <DataTableColumn field="start" header="Date"><template #body="{data}">{{getNiceDate(data.start)}} - {{getNiceTime(data.start)}}</template></DataTableColumn>
    <DataTableColumn field="duration" header="Durée"><template #body="{data}">{{writeMinutes(data.duration)}}</template></DataTableColumn>
    <DataTableColumn v-if="!props.lightVersion == true" field="ServiceComments" header="Service">
      <template #body="{data}">
        <span v-if="data.didNotShowUp === 'true'">Ne s'est pas pointé</span>
        <div v-else class="serviceCell">
          <div>{{serviceText(data)}}</div>
          <small v-if="hairText(data)">{{hairText(data)}}</small>
        </div>
      </template>
    </DataTableColumn>
    <DataTableColumn v-if="!props.lightVersion == true" field="ServiceAmount"  header="Montant Service"><template #body="{data}">{{data.serviceAmount}} CHF</template></DataTableColumn>
    <DataTableColumn v-if="!props.lightVersion == true" field="SalesAmount" header="Montant Ventes"><template #body="{data}">{{data.salesAmount}} CHF</template></DataTableColumn>
    <DataTableColumn v-if="!props.lightVersion == true" field="actions" header="Actions">
      <template #body="{data}">
        <InputButton
          icon="pi pi-send"
          label="Renvoyer SMS"
          class="p-button-text p-button-sm"
          v-if="canResendSms(data)"
        :disabled="resendingSmsByAppId === data.appid"
          @click.stop="resendConfirmationSms(data)"
        />
      </template>
    </DataTableColumn>
  </DataTable>
</div>
<div v-if="currentMonthApps.length > 0" class="mobileOnly">
  <div v-for="app in currentMonthApps" :key="app.appid" class="appCard" :class="{ 'appCard--open': app.closed !== 'true' }" @click="rowSelected({ data: app })">
    <div class="appCard__header">
      <span class="appCard__name">{{ app.name }}</span>
      <span class="appCard__badge" v-if="app.closed !== 'true'">Non clôturé</span>
    </div>
    <div class="appCard__details">
      <div class="appCard__row">
        <i class="pi pi-calendar"></i>
        <span>{{ getNiceDate(app.start) }} - {{ getNiceTime(app.start) }}</span>
      </div>
      <div class="appCard__row">
        <i class="pi pi-clock"></i>
        <span>{{ writeMinutes(app.duration) }}</span>
      </div>
      <div class="appCard__row" v-if="!props.lightVersion && app.didNotShowUp === 'true'">
        <i class="pi pi-times-circle"></i>
        <span>Ne s'est pas pointé</span>
      </div>
      <div class="appCard__row" v-else-if="!props.lightVersion && serviceText(app)">
        <i class="pi pi-briefcase"></i>
        <span>{{ serviceText(app) }}</span>
      </div>
      <div class="appCard__row" v-if="!props.lightVersion && hairText(app)">
        <i class="pi pi-info-circle"></i>
        <span class="appCard__hair">{{ hairText(app) }}</span>
      </div>
      <div class="appCard__amounts" v-if="!props.lightVersion">
        <span v-if="app.serviceAmount && app.serviceAmount !== '0'">Service: {{ app.serviceAmount }} CHF</span>
        <span v-if="app.salesAmount && app.salesAmount !== '0'">Ventes: {{ app.salesAmount }} CHF</span>
      </div>
    </div>
    <div class="appCard__actions" v-if="!props.lightVersion && canResendSms(app)">
      <InputButton icon="pi pi-send" label="Renvoyer SMS" class="p-button-text p-button-sm" :disabled="resendingSmsByAppId === app.appid" @click.stop="resendConfirmationSms(app)" />
    </div>
  </div>
</div>

<!-- Other months: collapsed accordions -->
<div v-if="otherMonthGroups.length > 0" class="monthAccordions">
  <div v-for="group in otherMonthGroups" :key="group.key" class="monthGroup">
    <button type="button" class="monthGroupHeader" @click="toggleMonth(group.key)">
      <i class="pi" :class="expandedMonths[group.key] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
      <span class="monthGroupLabel">{{ group.label }}</span>
      <span class="monthGroupCount">{{ group.appointments.length }}</span>
    </button>
    <div v-if="expandedMonths[group.key]" class="desktopOnly">
      <DataTable :value="group.appointments" :rowClass="rowClass" selectionMode="single" v-model:selection="selectedApp" @rowSelect="rowSelected" responsiveLayout="scroll" >
        <DataTableColumn field="name" header="Nom"></DataTableColumn>
        <DataTableColumn field="start" header="Date"><template #body="{data}">{{getNiceDate(data.start)}} - {{getNiceTime(data.start)}}</template></DataTableColumn>
        <DataTableColumn field="duration" header="Durée"><template #body="{data}">{{writeMinutes(data.duration)}}</template></DataTableColumn>
        <DataTableColumn v-if="!props.lightVersion == true" field="ServiceComments" header="Service">
          <template #body="{data}">
            <span v-if="data.didNotShowUp === 'true'">Ne s'est pas pointé</span>
            <div v-else class="serviceCell">
              <div>{{serviceText(data)}}</div>
              <small v-if="hairText(data)">{{hairText(data)}}</small>
            </div>
          </template>
        </DataTableColumn>
        <DataTableColumn v-if="!props.lightVersion == true" field="ServiceAmount"  header="Montant Service"><template #body="{data}">{{data.serviceAmount}} CHF</template></DataTableColumn>
        <DataTableColumn v-if="!props.lightVersion == true" field="SalesAmount" header="Montant Ventes"><template #body="{data}">{{data.salesAmount}} CHF</template></DataTableColumn>
        <DataTableColumn v-if="!props.lightVersion == true" field="actions" header="Actions">
          <template #body="{data}">
            <InputButton
              icon="pi pi-send"
              label="Renvoyer SMS"
              class="p-button-text p-button-sm"
              v-if="canResendSms(data)"
        :disabled="resendingSmsByAppId === data.appid"
              @click.stop="resendConfirmationSms(data)"
            />
          </template>
        </DataTableColumn>
      </DataTable>
    </div>
    <div v-if="expandedMonths[group.key]" class="mobileOnly">
      <div v-for="app in group.appointments" :key="app.appid" class="appCard" :class="{ 'appCard--open': app.closed !== 'true' }" @click="rowSelected({ data: app })">
        <div class="appCard__header">
          <span class="appCard__name">{{ app.name }}</span>
          <span class="appCard__badge" v-if="app.closed !== 'true'">Non clôturé</span>
        </div>
        <div class="appCard__details">
          <div class="appCard__row">
            <i class="pi pi-calendar"></i>
            <span>{{ getNiceDate(app.start) }} - {{ getNiceTime(app.start) }}</span>
          </div>
          <div class="appCard__row">
            <i class="pi pi-clock"></i>
            <span>{{ writeMinutes(app.duration) }}</span>
          </div>
          <div class="appCard__row" v-if="!props.lightVersion && serviceText(app)">
            <i class="pi pi-briefcase"></i>
            <span>{{ serviceText(app) }}</span>
          </div>
          <div class="appCard__amounts" v-if="!props.lightVersion">
            <span v-if="app.serviceAmount && app.serviceAmount !== '0'">Service: {{ app.serviceAmount }} CHF</span>
            <span v-if="app.salesAmount && app.salesAmount !== '0'">Ventes: {{ app.salesAmount }} CHF</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<DialogView v-model:visible="dialogVisible" :modal="true" style="width: min(760px, 95vw)">
  <template #header>
    <div class="dialogHeader">
      <div class="dialogTitle">Clôture du rendez-vous</div>
      <div class="dialogSubtitle">{{ selectedApp ? selectedApp.name : '' }}</div>
    </div>
  </template>

  <div class="appointmentEditor" v-if="selectedApp">
    <div class="editorSection">
      <h4>Statut</h4>
      <SelectButton v-model="appointmentStatus" :options="statusOptions" optionLabel="name" />
    </div>

    <div class="editorSection">
      <h4>Durée</h4>
      <label for="duration">Durée (minutes)</label>
      <div class="p-inputgroup">
        <InputText id="duration" v-model="form.duration" type="number" />
        <span class="p-inputgroup-addon">{{writeMinutes(form.duration || 0)}}</span>
      </div>
    </div>

    <div class="editorSection">
      <h4>Services et facturation</h4>
      <label for="serviceComments">Service</label>
      <TextArea id="serviceComments" v-model="form.serviceComments" type="text" />
      <label for="serviceAmount">Montant service</label>
      <div class="p-inputgroup">
        <InputText id="serviceAmount" v-model="form.serviceAmount" type="text" />
        <span class="p-inputgroup-addon">CHF</span>
      </div>

      <label for="salesComments">Ventes</label>
      <TextArea id="salesComments" v-model="form.salesComments" type="text" />
      <label for="salesAmount">Montant ventes</label>
      <div class="p-inputgroup">
        <InputText id="salesAmount" v-model="form.salesAmount" type="text" />
        <span class="p-inputgroup-addon">CHF</span>
      </div>
    </div>
  </div>

  <template #footer>
    <InputButton @click="updateAppointment" class="p-button-success">Sauvegarder</InputButton>
    <InputButton @click="closeDialog" class="p-button-secondary p-button-outlined">Annuler</InputButton>
  </template>
</DialogView>
</template>

<style scoped>
.dialogHeader {
  text-align: left;
}

.dialogTitle {
  font-weight: 700;
  font-size: 1.05rem;
}

.dialogSubtitle {
  color: #6b7280;
  margin-top: 2px;
}

.appointmentEditor {
  display: grid;
  gap: 14px;
  text-align: left;
}

.editorSection {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px;
  background: #fafafa;
}

.editorSection h4 {
  margin: 0 0 8px 0;
  font-size: 0.95rem;
}

.editorSection label {
  display: block;
  margin: 8px 0 4px 0;
  font-size: 0.9rem;
}

.serviceCell small {
  display: block;
  color: #64748b;
  margin-top: 2px;
}

.monthAccordions {
  margin-top: 10px;
  display: grid;
  gap: 6px;
}

.monthGroupHeader {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  cursor: pointer;
  font-size: 0.92rem;
  font-weight: 600;
  color: #1e293b;
  text-align: left;
  transition: background 0.12s;
}

.monthGroupHeader:hover {
  background: #eef3fb;
}

.monthGroupHeader i {
  font-size: 0.8rem;
  color: #94a3b8;
  flex-shrink: 0;
}

.monthGroupLabel {
  flex: 1;
}

.monthGroupCount {
  background: #e2e8f0;
  color: #475569;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 2px 8px;
}

/* Desktop table / mobile cards toggle */
.mobileOnly {
  display: none;
}

@media (max-width: 768px) {
  .desktopOnly {
    display: none;
  }
  .mobileOnly {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
}

/* Mobile appointment cards */
.appCard {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.7rem 0.85rem;
  background: #f8fafc;
  cursor: pointer;
  transition: background 0.12s;
}

.appCard:active {
  background: #eef3fb;
}

.appCard--open {
  border-left: 3px solid #ef4444;
  background: #fff5f5;
}

.appCard__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.4rem;
}

.appCard__name {
  font-weight: 700;
  font-size: 0.95rem;
  color: #1e293b;
  min-width: 0;
  overflow-wrap: anywhere;
}

.appCard__badge {
  flex-shrink: 0;
  font-size: 0.7rem;
  font-weight: 600;
  color: #dc2626;
  background: #fee2e2;
  border-radius: 999px;
  padding: 2px 8px;
}

.appCard__details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.appCard__row {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.85rem;
  color: #475569;
}

.appCard__row i {
  font-size: 0.8rem;
  color: #94a3b8;
  flex-shrink: 0;
  width: 1rem;
  text-align: center;
}

.appCard__hair {
  color: #64748b;
  font-size: 0.82rem;
}

.appCard__amounts {
  display: flex;
  gap: 0.8rem;
  margin-top: 0.3rem;
  font-size: 0.82rem;
  color: #64748b;
  flex-wrap: wrap;
}

.appCard__actions {
  margin-top: 0.4rem;
  padding-top: 0.35rem;
  border-top: 1px solid #e2e8f0;
}
</style>

<script setup>
import {ref, computed, reactive, defineProps, defineEmits} from 'vue';
import axios from 'axios'
import { useMainStore } from '../store'
import { authHeader } from '../helpers/authHeader.js';
import { getNiceDate, getNiceTime, writeMinutes} from  '../dateUtils.js';
import { parseStructuredAppointmentDetails, structuredHairSummary, structuredServiceSummary } from '../helpers/appointmentDisplay.js';

const props = defineProps(['appointments', 'listItemName', 'lightVersion', 'servicePrice']);
const emit = defineEmits(['appUpdated']);

const selectedApp = ref(null);
const dialogVisible = ref(false);
const appointmentStatus = ref({name:'Ouvert', value:'open'});
const resendingSmsByAppId = ref(null);
const expandedMonths = reactive({});
const form = ref({
  duration: '',
  serviceComments: '',
  serviceAmount: '0',
  salesComments: '',
  salesAmount: '0'
});

const store = useMainStore();

const monthNames = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];

function parseStart(start) {
  const normalized = String(start || "").trim().replace(" ", "T");
  const d = new Date(normalized);
  return Number.isNaN(d.getTime()) ? null : d;
}

const now = new Date();
const currentMonth = now.getMonth();
const currentYear = now.getFullYear();

const currentMonthApps = computed(() => {
  return (props.appointments || []).filter(app => {
    const d = parseStart(app.start);
    return d && d.getMonth() === currentMonth && d.getFullYear() === currentYear;
  });
});

const otherMonthGroups = computed(() => {
  const others = (props.appointments || []).filter(app => {
    const d = parseStart(app.start);
    return d && !(d.getMonth() === currentMonth && d.getFullYear() === currentYear);
  });

  const grouped = new Map();
  others.forEach(app => {
    const d = parseStart(app.start);
    if (!d) return;
    const key = `${d.getFullYear()}-${String(d.getMonth()).padStart(2, '0')}`;
    if (!grouped.has(key)) {
      grouped.set(key, {
        key,
        label: `${monthNames[d.getMonth()]} ${d.getFullYear()}`,
        year: d.getFullYear(),
        month: d.getMonth(),
        appointments: []
      });
    }
    grouped.get(key).appointments.push(app);
  });

  return Array.from(grouped.values()).sort((a, b) => {
    if (a.year !== b.year) return b.year - a.year;
    return b.month - a.month;
  });
});

function toggleMonth(key) {
  expandedMonths[key] = !expandedMonths[key];
}

const rowClass = (data) => {
  return data.closed === "true" ? null : 'row-notclosed';
};

const statusOptions = ref([
  {name:'Ouvert', value:'open'},
  {name: 'No Show', value:'noshow'},
  {name:'Clôturé', value:'closed'}
]);

function rowSelected(event) {
  const data = event.data;
  selectedApp.value = { ...data };

  form.value.duration = String(data.duration ?? '');
  form.value.serviceComments = data.serviceComments || '';
  form.value.salesComments = data.salesComments || '';
  form.value.serviceAmount = props.servicePrice ? String(props.servicePrice) : String(data.serviceAmount ?? '0');
  form.value.salesAmount = String(data.salesAmount ?? '0');

  let closed = data.closed;
  const noshow = data.didNotShowUp;
  if (props.servicePrice) {
    closed = "true";
  }

  if(closed === "true") {
    appointmentStatus.value = {name:'Clôturé', value:'closed'};
  } else if (noshow === "true") {
    appointmentStatus.value = {name:'No Show', value:'noshow'};
  } else {
    appointmentStatus.value = {name:'Ouvert', value:'open'};
  }

  dialogVisible.value = true;
}

function toNumber(value) {
  const normalized = String(value ?? '0').replace(',', '.').trim();
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
}

function toDuration(value, fallback) {
  const parsed = parseInt(String(value ?? '').trim(), 10);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return parseInt(String(fallback ?? 0), 10) || 0;
  }
  return parsed;
}

function closeDialog() {
  dialogVisible.value = false;
  selectedApp.value = null;
}

function serviceText(data) {
  const structured = parseStructuredAppointmentDetails(data?.details);
  if (structured) {
    return structuredServiceSummary(structured);
  }
  if (data?.serviceComments) {
    return data.serviceComments;
  }
  if (data?.details) {
    return data.details;
  }
  return "";
}

function hairText(data) {
  const structured = parseStructuredAppointmentDetails(data?.details);
  if (!structured) {
    return "";
  }
  return structuredHairSummary(structured);
}

function updateAppointment() {
  if (!selectedApp.value) {
    return;
  }

  const payload = {
    FlagClosed: appointmentStatus.value.value === "closed" ? "true" : "false",
    FlagDidNotShowUp: appointmentStatus.value.value === "noshow" ? "true" : "false",
    Duration: toDuration(form.value.duration, selectedApp.value.duration),
    ServiceComments: form.value.serviceComments || '',
    SalesComments: form.value.salesComments || '',
    ServiceAmount: toNumber(form.value.serviceAmount),
    SalesAmount: toNumber(form.value.salesAmount)
  };

  var options = {
    "headers" :  authHeader(true)
  };

  axios
    .post(`${process.env.VUE_APP_API_URL}/Appointments/updateAppManagement?appid=${selectedApp.value.appid}`, JSON.stringify(payload), options)
    .then(() => {
      store.$patch((state) => {
        state.currentClientFile = selectedApp.value.clientid;
      });
      closeDialog();
      emit('appUpdated');
    })
    .catch(reason => {
      console.log(reason);
      const message = reason?.response?.data?.message || reason?.message || 'Erreur lors de la mise à jour du rendez-vous.';
      alert(message);
    });
}

function resendConfirmationSms(app) {
  if (!app || !app.appid) {
    return;
  }

  if (!canResendSms(app)) {
    alert("Le SMS peut être renvoyé uniquement pour un rendez-vous futur.");
    return;
  }

  const confirmed = window.confirm("Renvoyer le SMS de confirmation pour ce rendez-vous ?");
  if (!confirmed) {
    return;
  }

  const options = {
    "headers" :  authHeader(true)
  };

  resendingSmsByAppId.value = app.appid;

  axios
    .post(`${process.env.VUE_APP_API_URL}/Appointments/resendConfirmationSms?appid=${app.appid}`, JSON.stringify({}), options)
    .then(() => {
      resendingSmsByAppId.value = null;
      alert("SMS de confirmation renvoyé.");
    })
    .catch((reason) => {
      resendingSmsByAppId.value = null;
      console.log(reason);
      const message = reason?.response?.data?.message || reason?.message || "Impossible d'envoyer le SMS.";
      alert(message);
    });
}

function canResendSms(app) {
  if (!app || !app.start) {
    return false;
  }
  const appDate = parseStart(app.start);
  if (!appDate) {
    return false;
  }
  return appDate.getTime() > Date.now();
}
</script>
